export default "__VITE_ASSET__merQDSvI__"